import(/* webpackMode: "eager" */ "/codebuild/output/src4149877583/src/hvac-next/app/(text-pages)/page.module.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4149877583/src/hvac-next/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4149877583/src/hvac-next/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4149877583/src/hvac-next/public/img/icons/IconLinkedIn.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4149877583/src/hvac-next/public/img/profile/team-photo-dave.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4149877583/src/hvac-next/public/img/profile/team-photo-jennifer.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4149877583/src/hvac-next/public/img/profile/team-photo-jess.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4149877583/src/hvac-next/public/img/profile/team-photo-kevin-m.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4149877583/src/hvac-next/public/img/profile/team-photo-kevin.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4149877583/src/hvac-next/public/img/profile/team-photo-ray.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4149877583/src/hvac-next/public/img/profile/team-photo-shelby.webp");
